import ArticlePublishDialog from './publish-dialog'
import ResourcesDialog from './resources-dialog'
import ToggleSwitch from '../ToggleSwitch'
import Button from '../Button'
import { showNotification } from '../Notification'
import Typography from '../Typography'
import { navigate } from 'vike/client/router'
import { useSearchParamValue } from '../../utils/searchParams'
import ArticleBrowser from './article-browser'
import HtmlEditor from './html-editor'
import CategoryDialog from './category-dialog'

export default ({ controller }) => {
  const showArticleMenu = useSearchParamValue('article') != null

  const {
    editMode,
    setEditMode,
    articlePayload,
    setResourcesOpen,
    setPublishOpen,
    resourcesOpen,
    browserOpen,
    setBrowserOpen,
    refreshArticle,
    editorOpen,
    setEditorOpen,
    setCategoriesOpen,
  } = controller

  const refreshContent = () => {
    const isBlogPage = window.location.search.includes('page')
    if (isBlogPage) {
      navigate('/blog?page=refresh')
    } else {
      refreshArticle()
    }
  }

  return (
    <div style={{ zIndex: 200 }}>
      {/* Dialogs */}
      <ArticlePublishDialog controller={controller} />

      <ResourcesDialog
        articleID={articlePayload?.articleID}
        isOpen={resourcesOpen}
        onCloseRequested={() => setResourcesOpen(false)}
      />

      <ArticleBrowser
        controller={controller}
        isOpen={browserOpen}
        onCloseBtnClick={refreshContent}
        onCloseRequested={() => {
          setBrowserOpen(false)
        }}
      />
      <HtmlEditor controller={controller} />
      <CategoryDialog controller={controller} />
      {/* Menu */}
      <div className="flex flex-col fixed right-[0px] w-[220px] top-[65px]">
        <Button
          className="bg-paper font-bold text-text"
          onClick={() => navigate('/blog?article=new')}
        >
          New Article
        </Button>

        <Button
          className="bg-paper font-bold text-text"
          onClick={() => setBrowserOpen(true)}
        >
          Browser
        </Button>
        <Button
          className="w-full bg-paper font-bold text-text"
          onClick={() => controller.newCategory()}
        >
          Categories
        </Button>

        {/* Article related buttons */}
        {showArticleMenu && (
          <div className="flex-1 w-full">
            <Button
              className="w-full bg-paper font-bold text-text"
              onClick={() => navigate('/blog?page=refresh')}
            >
              Go to Blog Home
            </Button>
            <Button
              className="w-full bg-paper font-bold text-text"
              onClick={() => setResourcesOpen(true)}
            >
              Resources
            </Button>
            {/* Edit Mode Switch */}
            <div className="bg-paper px-5 flex flex-row gap-2 w-full items-center">
              <ToggleSwitch isOn={editMode} onChange={setEditMode} />
              <Typography variant="paragraph" className="text-text_secondary">
                Edit in VSCode
              </Typography>
            </div>

            <Button
              className="w-full bg-paper font-bold text-text"
              onClick={() => setEditorOpen(true)}
            >
              Edit HTML
            </Button>

            <Button
              variant="action"
              className="w-full  font-bold text-text"
              onClick={() => setPublishOpen(true)}
            >
              Publish
            </Button>
            {/* Article status*/}
            <div
              variant="paragraph"
              className="bg-aldoo_black text-center w-full text-text_secondary"
            >
              {articlePayload?.status == 'published'
                ? 'Article is Live'
                : 'Article is Draft'}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
